/*

==================================================================================================

CUSTOM POST FILTERED RESULTS

==================================================================================================

*/

import { waitForElm } from "./helpers";

/**
 * A custom wrapper to watch for meal plan filters
 *
 * @class PostFilteredResults
 * @typedef {PostFilteredResults}
 * @extends {HTMLElement}
 */
class PostFilteredResults extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * Return the value of all / the most recent filter value
   * HELPER
   *
   * @param {string} str
   * @returns {string}
   */
  getFacet(str) {
    return str.split("=")[1];
  }

  /**
   * Return the value of all / the most recent filter label / type
   * HELPER
   *
   * @param {string} str
   * @returns {string}
   */
  getFilter(str) {
    let x = str.split(".");
    let y = x.slice(-1)[0];
    return y.split("=")[0];
  }

  /**
   * Hooks into our lifecycle and watches for changes to the "data-active" attribute
   *
   * @static
   * @readonly
   * @type {{}}
   */
  static get observedAttributes() {
    return ["data-active"];
  }

  /**
   * Recurve function that occurs every time the observed data attributes change
   * This will run every time the filters change - Adding and Removing of filters
   *
   * @param {string} name
   * @param {string} oldValue
   * @param {string} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    let dataFacets = this.getAttribute("data-active");
    if (name == "data-active") {
      this.filterByFacets(dataFacets);
    }
  }

  /**
   * Takes the current filter params & compares them to the product filters attached to the product card (via "data-connected-filters" attribute)
   * If the accosted card filters match the current active ones, then hide the meals that match
   *
   *
   * @param {string} d - Gets converted to an array, ready to be mapped
   */
  filterByFacets(d) {
    let currentFilters = d.split(",");
    currentFilters.pop();
    // console.log('active filters: ', currentFilters);
    waitForElm(".post-filters").then((elm) => {
      let length = this.querySelectorAll(`.post-filters [js-product-card="container"]`).length;
      this.querySelectorAll(`.post-filters [js-product-card="container"]`).forEach((c, i) => {
        currentFilters.map((f) => {
          let singleFilters = c
            .getAttribute("data-connected-filters")
            .split("|");
          singleFilters.map((sf) => {
            if (sf == f) {
              c.classList.add("reverse-filtered");
            }
          });
        });
      });
      let fLength = this.querySelectorAll(
        `.post-filters [js-product-card="container"].reverse-filtered`,
      ).length;
      if (fLength === length) {
        this.querySelector(".post-filters").classList.add("visually-hidden");
      }
    });
  }

  /**
   * Fetch all the current meals in the collection, and then rehydrate the container on mount / re-mount
   *
   * @async
   * @returns {*}
   */
  async oppositeFilters() {
    try {
      const response = await axios.get(
        window.Shopify.routes.root +
          "collections/create-meal-plan?view=ignore-filters",
      );
      const res = await response;
      if (res.status !== 200) {
        throw new Error(`Request failed with status ${res.status}`);
      }
      let p = new DOMParser();
      let doc = p.parseFromString(res.data, "text/html");
      let _items = doc.querySelector("#ignored-filters-wrapper").innerHTML;

      const urlParams = window.location.search;

      let params = urlParams.split("&");
      let activeFilters = [];

      if (params) {
        params.map((p, i) => {
          if (p.includes("filter.")) {
            let _facet = this.getFacet(p);
            let _filter = this.getFilter(p);
            activeFilters.push({_filter, _facet});
          }
        });
      }

      this.filterOut(activeFilters, _items);
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * Hydrate the container and place all the meals in by default...
   * Then filter out any meals that have data attributes that match the active filters parsed
   *
   * @param {array} f
   * @param {string} items
   */
  filterOut(f, items) {
    this.innerHTML = items;
  }

  /**
   * On mount, run the lifecycle
   */
  connectedCallback() {
    this.oppositeFilters();
  }
}

customElements.define("post-filtered-results", PostFilteredResults);
